module.exports = __webpack_public_path__ + "static/media/vklogo.9b4f5df6.png";